/**
 * The DistribuAI mark (its two arrows) and Ask's orb: the mark in a white circle with the slowly
 * turning colour halo behind it (the explainer video's and the Ask page sketch's).
 */
import { cx } from '@/kit/cx'

export function Mark({ width = 9, className, color = 'currentColor' }: { width?: number; className?: string; color?: string }) {
    return (
        <svg aria-hidden="true" width={width} height={(width * 128) / 85} viewBox="0 0 85 128" fill={color} className={cx('shrink-0', className)}>
            <path d="M0 127.933V0C0 35.3382 28.6369 64 63.9445 64C28.6369 64 0 92.6618 0 128V127.933Z" />
            <path d="M20.6133 127.933V0C20.6133 35.3382 49.2502 64 84.5578 64C49.2502 64 20.6133 92.6618 20.6133 128V127.933Z" />
        </svg>
    )
}

/** The orb, `size` px across; its halo `halo` times that, dimmed when `calm`. */
export function Orb({ size = 68, halo = 3.2, calm = false, className }: { size?: number; halo?: number; calm?: boolean; className?: string }) {
    const haloSize = size * halo
    return (
        <span className={cx('relative inline-flex shrink-0 items-center justify-center', className)} style={{ width: size, height: size }}>
            <span
                aria-hidden="true"
                className="ask-halo ask-halo-colors pointer-events-none absolute rounded-full transition-opacity duration-500"
                style={{ width: haloSize, height: haloSize, left: (size - haloSize) / 2, top: (size - haloSize) / 2, filter: `blur(${Math.max(4, size * 0.4)}px)`, opacity: calm ? 0.45 : 0.85 }}
            />
            <span className="ask-orb absolute inset-0 flex items-center justify-center rounded-full bg-[var(--surface-raised)] shadow-[0_2px_12px_rgba(16,16,19,0.12)]">
                <Mark width={Math.round(size * 0.3)} color="var(--text-default)" />
            </span>
        </span>
    )
}
